import { useEffect, useRef } from 'react';
import { kindsBelowMinimumSync } from '../store';
import { PMS } from '@/features/shared/pms';

function inWords(items: string[]): string {
  if (items.length <= 1) return items.join('');
  return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1] ?? ''}`;
}

export function Milestone({ onTurnOn, onKeep }: { onTurnOn: () => void; onKeep: () => void }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ref.current?.querySelector<HTMLElement>('button')?.focus();
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') { e.preventDefault(); onKeep(); } };
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('keydown', onKey); };
  }, [onKeep]);
  return (
    <div className="po-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onKeep(); }}>
      <div ref={ref} className="po-dialog" role="dialog" aria-modal="true" aria-label="ELVA is ready to post payments on its own">
        <span className="po-eyebrow">100 of 100 confirmed</span>
        <h2 className="po-dialog-title">ELVA is ready to post payments on its own</h2>
        <p className="po-dialog-body">You and your team confirmed 100 postings. You changed 6 of them, and ELVA learned from each change. In the last 30, you changed none.</p>
        <div>
          <p className="po-label" style={{ marginBottom: 6 }}>With autopilot on</p>
          <ul style={{ margin: 0, paddingLeft: 18, display: 'flex', flexDirection: 'column', gap: 6, fontSize: 14, color: 'var(--fg2)' }}>
            <li>Payments ELVA has everything for are posted in {PMS} without waiting for you.</li>
            <li>Anything that needs a decision still comes to you, with the reason.</li>
            <li>Kinds of payment ELVA hasn’t posted enough of keep coming to you. Today that’s {inWords(kindsBelowMinimumSync())}.</li>
            <li>Every posting is in Posted, step by step, and can be undone.</li>
            <li>You can turn it off at any time.</li>
          </ul>
        </div>
        <div className="po-dialog-actions">
          <button type="button" className="po-btn po-btn-primary" onClick={onTurnOn}>Turn on autopilot</button>
          <button type="button" className="po-btn" onClick={onKeep}>Keep confirming for now</button>
        </div>
      </div>
    </div>
  );
}
